export default "__VITE_ASSET__J7G3fGrP__"